import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { useOpenProductInfoModal } from '../../useOpenProductInfoModal'

import { InfoButton, InfoButtonRow } from './styled'

type ProductInfoButtonProps = {
  product: IProduct
}

// QRM-640: the "i" button — shown for ANY product that has ingredients and/or
// nutritional information configured in CashAssist (hasProductInfo from products_v2),
// no longer limited to weight items.
export const ProductInfoButton: FC<ProductInfoButtonProps> = ({ product }) => {
  const t = useTranslations()
  const openProductInfo = useOpenProductInfoModal()

  return (
    <RenderIf condition={product.hasProductInfo === true}>
      <InfoButtonRow>
        <InfoButton
          type="button"
          aria-label={t('productInfo.open')}
          data-testid="product_info_button"
          onClick={() => openProductInfo(product)}
        >
          i
        </InfoButton>
      </InfoButtonRow>
    </RenderIf>
  )
}
